import { MODULE_META } from "@/lib/nav";
import { PageHeader, EmptyState, Pill } from "@/components/shared";

export default function ModulePlaceholder({ moduleKey }) {
  const meta = MODULE_META[moduleKey] || { title: moduleKey, description: "Module coming soon.", icon: "Layers" };

  return (
    <div data-testid={`module-${moduleKey}`}>
      <PageHeader title={meta.title} description={meta.description} />
      <div className="bg-white border border-slate-200 rounded-xl shadow-sm">
        <EmptyState
          icon={meta.icon}
          title="Coming soon"
          description="This department is part of the Tax Flow roadmap and will be built on the enterprise foundation. Navigation, permissions, and data frameworks are already in place."
          action={<Pill tone="warning">Roadmap module</Pill>}
        />
      </div>
    </div>
  );
}
